import { put, select, takeLatest } from 'redux-saga/effects'
import { getTimesSelector } from '../selectors'
import {
  setAcknowledgedDate,
  setAcknowledgedTime,
  setArriveReceivingDate,
  setArriveReceivingTime,
  setAtPatientDate,
  setAtPatientTime,
  setAvailableDate,
  setAvailableTime,
  setCallCompletedDate,
  setCallCompletedTime,
  setCancelledDate,
  setCancelledTime,
  setDispatchedDate,
  setDispatchedTime,
  setDispatchNotifiedDate,
  setDispatchNotifiedTime,
  setEnRouteDate,
  setEnRouteTime,
  setInQuartersDate,
  setInQuartersTime,
  setLeaveReferringDate,
  setLeaveReferringTime,
  setLeavePatientDate,
  setLeavePatientTime,
  setDescentDate,
  setDescentTime,
  setAtLandingDate,
  setAtLandingTime,
  setOnSceneDate,
  setOnSceneTime,
  setOnsetDate,
  setOnsetTime,
  setReceivedDate,
  setReceivedTime,
  setStagingDate,
  setStagingTime,
  setStandbyDate,
  setStandbyTime,
  setTransferCareDestinationDate,
  setTransferCareDestinationTime,
  setTransferCareEMSDate,
  setTransferCareEMSTime,
  setCustom4Time,
  setCustom4Date,
  setCustom3Time,
  setCustom3Date,
  setCustom2Time,
  setCustom2Date,
  setCustom1Time,
  setCustom1Date,
} from '../store/times.actions'
import { TimesConstants } from '../store/times.constants'
import { ITimesState } from '../store/times.types'

export function* reRunTimesValidations() {
  const times: ITimesState = yield select(getTimesSelector)
  const {
    onsetTime,
    receivedTime,
    dispatchNotifiedTime,
    standbyTime,
    dispatchedTime,
    acknowledgedTime,
    enRouteTime,
    onsetDate,
    receivedDate,
    dispatchNotifiedDate,
    standbyDate,
    dispatchedDate,
    acknowledgedDate,
    enRouteDate,
    stagingTime,
    onSceneTime,
    atPatientTime,
    transferCareEMSTime,
    leaveReferringTime,
    arriveReceivingTime,
    transferCareDestinationTime,
    availableTime,
    callCompletedTime,
    inQuartersTime,
    cancelledTime,
    stagingDate,
    onSceneDate,
    atPatientDate,
    transferCareEMSDate,
    leaveReferringDate,
    arriveReceivingDate,
    transferCareDestinationDate,
    availableDate,
    callCompletedDate,
    inQuartersDate,
    cancelledDate,
    leavePatientDate,
    leavePatientTime,
    descentDate,
    descentTime,
    atLandingDate,
    atLandingTime,
    custom1Date,
    custom1Time,
    custom2Date,
    custom2Time,
    custom3Date,
    custom3Time,
    custom4Date,
    custom4Time,
  } = times

  if (onsetTime) yield put(setOnsetTime(onsetTime))
  if (receivedTime) yield put(setReceivedTime(receivedTime))
  if (dispatchNotifiedTime) yield put(setDispatchNotifiedTime(dispatchNotifiedTime))
  if (standbyTime) yield put(setStandbyTime(standbyTime))
  if (dispatchedTime) yield put(setDispatchedTime(dispatchedTime))
  if (acknowledgedTime) yield put(setAcknowledgedTime(acknowledgedTime))
  if (enRouteTime) yield put(setEnRouteTime(enRouteTime))
  if (onsetDate) yield put(setOnsetDate(onsetDate))
  if (receivedDate) yield put(setReceivedDate(receivedDate))
  if (dispatchNotifiedDate) yield put(setDispatchNotifiedDate(dispatchNotifiedDate))
  if (standbyDate) yield put(setStandbyDate(standbyDate))
  if (dispatchedDate) yield put(setDispatchedDate(dispatchedDate))
  if (acknowledgedDate) yield put(setAcknowledgedDate(acknowledgedDate))
  if (enRouteDate) yield put(setEnRouteDate(enRouteDate))
  if (stagingTime) yield put(setStagingTime(stagingTime))
  if (onSceneTime) yield put(setOnSceneTime(onSceneTime))
  if (atPatientTime) yield put(setAtPatientTime(atPatientTime))
  if (transferCareEMSTime) yield put(setTransferCareEMSTime(transferCareEMSTime))
  if (leaveReferringTime) yield put(setLeaveReferringTime(leaveReferringTime))
  if (arriveReceivingTime) yield put(setArriveReceivingTime(arriveReceivingTime))
  if (transferCareDestinationTime) yield put(setTransferCareDestinationTime(transferCareDestinationTime))
  if (availableTime) yield put(setAvailableTime(availableTime))
  if (callCompletedTime) yield put(setCallCompletedTime(callCompletedTime))
  if (inQuartersTime) yield put(setInQuartersTime(inQuartersTime))
  if (cancelledTime) yield put(setCancelledTime(cancelledTime))
  if (stagingDate) yield put(setStagingDate(stagingDate))
  if (onSceneDate) yield put(setOnSceneDate(onSceneDate))
  if (atPatientDate) yield put(setAtPatientDate(atPatientDate))
  if (transferCareEMSDate) yield put(setTransferCareEMSDate(transferCareEMSDate))
  if (leaveReferringDate) yield put(setLeaveReferringDate(leaveReferringDate))
  if (arriveReceivingDate) yield put(setArriveReceivingDate(arriveReceivingDate))
  if (transferCareDestinationDate) yield put(setTransferCareDestinationDate(transferCareDestinationDate))
  if (callCompletedDate) yield put(setAvailableDate(availableDate))
  if (callCompletedDate) yield put(setCallCompletedDate(callCompletedDate))
  if (inQuartersDate) yield put(setInQuartersDate(inQuartersDate))
  if (cancelledDate) yield put(setCancelledDate(cancelledDate))
  if (leavePatientDate) yield put(setLeavePatientDate(leavePatientDate))
  if (leavePatientTime) yield put(setLeavePatientTime(leavePatientTime))
  if (descentDate) yield put(setDescentDate(descentDate))
  if (descentTime) yield put(setDescentTime(descentTime))
  if (atLandingDate) yield put(setAtLandingDate(atLandingDate))
  if (atLandingTime) yield put(setAtLandingTime(atLandingTime))
  if (custom1Date) yield put(setCustom1Date(custom1Date))
  if (custom1Time) yield put(setCustom1Time(custom1Time))
  if (custom2Date) yield put(setCustom2Date(custom2Date))
  if (custom2Time) yield put(setCustom2Time(custom2Time))
  if (custom3Date) yield put(setCustom3Date(custom3Date))
  if (custom3Time) yield put(setCustom3Time(custom3Time))
  if (custom4Date) yield put(setCustom4Date(custom4Date))
  if (custom4Time) yield put(setCustom4Time(custom4Time))
}

export function* reRunTimesValidationsSaga() {
  yield takeLatest([TimesConstants.RE_RUN_TIMES_VALIDATIONS], reRunTimesValidations)
}
